













































































import { bus } from '@/ts/main';

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HamburgerButton extends Vue {
    @Prop({ default: false }) openActive?: boolean;

    active: boolean = false;

    created() {
        if (this.openActive) this.active = true;

        bus.$on('hamburger-close', () => {
            this.active = false;
        });

        bus.$on('hamburger-open', () => {
            this.active = true;
        });
    }

    toggleMenu() {
        if (this.active) {
            bus.$emit('hamburger-close');
        } else {
            bus.$emit('hamburger-open');
        }

        // @ts-ignore
        this.$root.navigationIsVisble = !this.$root.navigationIsVisble;
    }
}
